import { createInitialUserPreferences, localStorageKey, useGlobalStore } from "./store";
import environment from "@app/config/environment";
import webSocket from "@app/config/webSocket";
import { shutdown as intercomShutdown } from "@intercom/messenger-js-sdk";
import { setUser } from "@sentry/react";
import posthog from "posthog-js";

/**
 * Clears all application state including localStorage, Zustand store,
 * and analytics user data.
 *
 * This should be called when:
 * - User logs out
 * - User changes (different user logs in)
 * - Organization changes
 * - Auth errors occur that require full cleanup
 */
export const clearApplicationState = (): Promise<void> => {
  return new Promise(resolve => {
    // 1. Close WebSocket connection to prevent connecting with stale credentials
    webSocket.close();

    // 2. Clear localStorage first to prevent Zustand from reading stale data
    localStorage.removeItem(localStorageKey);

    // 3. Reset Zustand store to initial state
    useGlobalStore.setState({
      user: null,
      selectedTeam: null,
      experimentStatus: new Map(),
      userPreferences: createInitialUserPreferences(),
      dismissedCortexWarningIds: []
    });

    // 4. Clear localStorage again to ensure it's completely clean
    // (in case Zustand persisted the reset state)
    localStorage.removeItem(localStorageKey);

    // 5. Reset PostHog user data
    posthog.reset();

    // 6. Clear Sentry user context
    setUser(null);

    // 7. Intercom shutdown
    if (environment.ATI_PUBLIC_INTERCOM_APP_ID) {
      intercomShutdown();
    }

    resolve();
  });
};
